module.exports = __webpack_public_path__ + "img/xm.18660118.png";